<template>
  <div :class="{ 'about-block': true, 'about-block-stay-bottom': stayBottom }">
    <div v-if="termsFromApi" v-html="termsFromApi"></div>
    <template v-else>
      <div class="tel">康太數位服務專線：(02) 7729-9040</div>
      <div class="tel">服務時間：週一~週五 09:00-18:00</div>
    </template>
    <div class="link">
      <span class="link-to" @click="toGuideline">使用規範</span>
      <span class="seperate">|</span>
      <span class="link-to" @click="toPrivacy">隱私權政策</span>
      <span class="seperate">|</span>
      <span class="link-to" @click="toService">客服中心</span>
      <div class="text">
        享樂券內容由康太數位提供，若有任何服務
        <br />
        需求請洽康太數位
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutBlock',
  data: function() {
    return {
      termsFromApi: '',
    }
  },
  props: {
    stayBottom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    useMock() {
      return process.env.VUE_APP_USE_TESTLOGIN == 'true'
    },
  },
  methods: {
    showToken() {
      const token = JSON.parse(localStorage.getItem('PI_TOKEN'))
      const str = `access_token: ${token.access_token.slice(-5)}...\n
      refresh_token: ${token.refresh_token.slice(-5)}...\n
      active_time: ${token.active_time}\n
      `
      alert(str)
    },
    toGuideline() {
      this.$router.push({ name: 'GuideLine' })
    },
    toPrivacy() {
      this.$router.push({ name: 'Privacy' })
    },
    toShip() {
      this.$router.push({ name: 'orderListGoods' })
    },
    toTicket() {
      this.$router.push({ name: 'orderListTicket' })
    },
    toService() {
      this.$router.push({ name: 'customerServicePage' })
    },
    toCollection() {
      this.$router.push({ name: 'collectionList' })
    },
  },
  created() {
    this.termsFromApi = JSON.parse(
      window.localStorage.getItem('initial_config')
    ).terms.declare
  },
}
</script>

<style scoped lang="scss">
.about-block {
  background-color: #f3f5f8;
  color: #4b4b4b;
  width: 100%;
  text-align: center;
  padding: 16px 4.3% 0;
  box-sizing: border-box;
  font-size: 0.8125rem;
  line-height: 1.54;
  .tel {
    font-size: 16px;
    line-height: 30px;
  }
  .text {
    white-space: nowrap;
    font-size: 15px;
    line-height: 26px;
    padding-top: 10px;
    opacity: 0.8;
  }
}
.link {
  padding: 0.5rem 0 0.75rem 0;
}
.link-to {
  text-decoration: none;
  font-size: 16px;
  line-height: 30px;
  color: #4b4b4b;
}
.seperate {
  color: rgba(75, 75, 75, 0.3);
  font-size: 16px;
  margin: 0 1.5rem;
}
</style>
